import type { SdkPersistConfig } from "@payping/redux";
import localForage from "localforage";

const storeVersion = 4;

const whitelist = ["auth", "user", "settings", "loginRedirect", "tour", "dashboardPersist"];

const persistConfig: SdkPersistConfig = {
  storage: localForage,
  version: storeVersion,
  whitelist,
};

export default { ...persistConfig };
